document.addEventListener('DOMContentLoaded', function () {
    //  ====================================  START: Main Add to Cart Buttton JS ====================================
    // Quantity selector
    const wrapper = document.querySelector(".quantity-wrapper");
    if (wrapper) {
    const input = wrapper.querySelector(".select-on-focus");
    const addBtn = document.querySelector(".hero-add");
    wrapper.addEventListener("click", function (e) {
        const up = e.target.closest('[data-quantity="up"]');
        const down = e.target.closest('[data-quantity="down"]');
        if (!up && !down) return;
        e.preventDefault();
        e.stopPropagation();
        let qty = parseInt(input.value) || 1;
        if (up) qty += 1;
        if (down && qty > 1) qty -= 1;
        input.value = qty;
        if (addBtn) addBtn.setAttribute("data-qty", qty);
    });
    }

    // Add to cart
    document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.hero-add');
    if (!btn) return;
    const mainId = btn.dataset.id;
    if (!mainId) {
        console.log('No main product ID found!');
        return;
    }
    // ALWAYS read the quantity fresh here
    const qty = parseInt(btn.dataset.qty) || 1;
    // Get checked addon IDs
    const addonIds = [...document.querySelectorAll('.addon-checkbox:checked')]
        .map(cb => parseInt(cb.value));
    btn.classList.add('loading');
    try {
        // Add main product with current quantity
        const mainResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: parseInt(mainId),
                quantity: qty
            })
        });
        const mainData = await mainResponse.json();
        // Add addons with same quantity
        for (const id of addonIds) {
            const addonResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                id,
                quantity: 1
                })
            });
            const addonData = await addonResponse.json();
        }
        // Refresh cart drawer
        const sectionData = await fetch('/?sections=cart-drawer,header').then(r => r.json());
        document.querySelector('cart-drawer').innerHTML =
        new DOMParser().parseFromString(sectionData['cart-drawer'], 'text/html')
        .querySelector('cart-drawer').innerHTML;

        const cart = await fetch('/cart.js').then(r => r.json());
        const cartCountEl = document.querySelector('.cart-count');
        if (cartCountEl) {
            cartCountEl.textContent = cart.item_count;
        }
        document.querySelector('#cart-icon--bubble')?.click();

    } catch (err) {
        console.error('Error adding to cart:', err);
    } finally {
        btn.classList.remove('loading');
    }
    });
    // ===================================    END :  Main Add to Cart Buttton Js =========================================

    // =========================== START :You May Also JS =====================================
    document.addEventListener('click', async (e) => {
        const btn = e.target.closest('.quiz-secondary a.secondary-btn');
        if (!btn) return;
        const id = btn.dataset.id;
        if (!id) return;
        btn.classList.add('loading');
        await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: 1 })
        });
        const data = await fetch('/?sections=cart-drawer,header').then(r => r.json());
        document.querySelector('cart-drawer').innerHTML =
        new DOMParser().parseFromString(data['cart-drawer'], 'text/html')
        .querySelector('cart-drawer').innerHTML;
        const cart = await fetch('/cart.js').then(r => r.json());
        const cartCountEl = document.querySelector('.cart-count');
            if (cartCountEl) {
            cartCountEl.textContent = cart.item_count;
            }
        document.querySelector('#cart-icon--bubble')?.click();
        btn.classList.remove('loading');
    });

    // =========================== END :You May Also JS ============================

    //  ========================= START : Variant Changes JS =============

    let selectedValues = [];
    let selectedVariant = '';
    let variantId = null;

    const addButton = document.querySelector('.hero-add');
    const targetImg = document.querySelector('.quiz-result-wrapper .quiz-hero .custom-quiz-left-part .quiz-hero-image img');

    // --- Stock Check ---
    function updateAddButtonStock() {
        if (!selectedVariant) return;

        // Find the matching hidden option
        const option = Array.from(document.querySelectorAll('.custom-option-hidden option'))
            .find(opt => opt.textContent.trim() === selectedVariant);

        if (!option) {
            addButton.disabled = true;
            addButton.innerText = "OUT OF STOCK";
            return;
        }

        const stock = option.getAttribute('data-stock') || "0";

        if (parseInt(stock) <= 0) {
            addButton.disabled = true;
            addButton.innerText = "OUT OF STOCK";
        } else {
            addButton.disabled = false;
            addButton.innerText = "ADD THIS TO MY WARDROBE";
        }
    }


    // --- Find Variant ---
    function findVariant() {
        const options = document.querySelectorAll('.custom-option-hidden option');

        options.forEach(option => {
            const optionText = option.textContent.trim();

            if (optionText === selectedVariant) {
                variantId = option.value;
                addButton.setAttribute('data-id', variantId);

                // Update Price
                const priceContainer = document.querySelector('.custom-quiz-right-part .price');
                if (priceContainer) {
                    const variantPrice = option.getAttribute('data-price');
                    if (variantPrice) priceContainer.textContent = `$${parseFloat(variantPrice).toFixed(2)}`;
                }

                // Update stock button
                updateAddButtonStock();
            }
        });
    }

    // --- Swatch Click Handler (once) ---
    function initSwatches() {
        const swatches = document.querySelectorAll('.color-swatches .swatch-circle');

        swatches.forEach(swatch => {
            swatch.addEventListener('click', () => {
                const bgImage = window.getComputedStyle(swatch).backgroundImage;
                if (bgImage && bgImage !== 'none') {
                    const url = bgImage.slice(5, -2);
                    targetImg.src = url;
                }

                // Update selected variant value
                const value = swatch.getAttribute('data-value');
                selectedValues[0] = value;
                selectedVariant = selectedValues.filter(Boolean).join(' / ');
                findVariant();
            });
        });
    }

    // --- Handle Option Change ---
    function handleOptionChange(inputSelector, index) {
        const inputs = document.querySelectorAll(inputSelector);
        if (!inputs.length) return;

        inputs.forEach(input => {
            input.addEventListener('change', function () {
                if (!this.checked) return;

                const value = this.value;
                selectedValues[index] = value;
                selectedVariant = selectedValues.filter(Boolean).join(' / ');

                const variantGroup = this.closest('.variant-group');
                if (variantGroup) {
                    const selectedOption = variantGroup.querySelector('.selected-option');
                    if (selectedOption) selectedOption.textContent = value;
                }

                findVariant();
            });
        });

        // Auto select first option
        inputs[0].checked = true;
        inputs[0].dispatchEvent(new Event('change'));
    }

    // --- Initialize ---
    handleOptionChange('.variant-group .color-swatches input', 0);
    handleOptionChange('.variant-group .size-buttons input', 1);
    initSwatches();
    updateAddButtonStock();

    //   ===================== END : Variant Changes JS ================



    // ==================== START :  Variant change dtock update JS ====================

    const colorInputs = document.querySelectorAll('.quiz-hero-content .variant-group .color-swatch input');
    const sizeLabels = document.querySelectorAll('.size-buttons .size-option');
    const hiddenOptions = document.querySelectorAll('.custom-option-hidden option');
    const colorLabels = document.querySelectorAll('.quiz-hero-content .variant-group .color-swatch');

    function updateVariants(selectedColor = null){

        let firstAvailableSize = null;

        // SIZE UPDATE
        sizeLabels.forEach(label => {

        const size = label.querySelector('span').textContent.trim();
        const input = label.querySelector('input');

        let option;

        // PRODUCT WITH COLOR
        if(selectedColor){
            option = Array.from(hiddenOptions).find(opt =>
            opt.textContent.trim() === `${selectedColor} / ${size}`
            );
        }
        // PRODUCT WITH ONLY SIZE
        else{
            option = Array.from(hiddenOptions).find(opt =>
            opt.textContent.trim() === size
            );
        }

        const stock = option ? parseInt(option.dataset.stock) : 0;

        label.dataset.stock = stock;

        if(stock > 0){

            label.removeAttribute('disabled');

            if(!firstAvailableSize){
            firstAvailableSize = input;
            }

        }else{

            label.setAttribute('disabled','');
            input.checked = false;

        }

        });


        // AUTO SELECT FIRST AVAILABLE SIZE
        const checkedSize = document.querySelector('.size-option input:checked');

        if(!checkedSize && firstAvailableSize){
        firstAvailableSize.checked = true;

         // trigger change event so variant + stock updates
        firstAvailableSize.dispatchEvent(new Event('change', { bubbles: true }));
        }


        // COLOR CHECK (only if color exists)
        if(colorLabels.length){

        colorLabels.forEach(label => {

            const colorValue = label.querySelector('input').value;

            const variants = Array.from(hiddenOptions).filter(opt =>
            opt.textContent.includes(colorValue)
            );

            const hasStock = variants.some(opt =>
            parseInt(opt.dataset.stock) > 0
            );

            if(hasStock){
            label.removeAttribute('disabled');
            }else{
            label.setAttribute('disabled','');
            }

        });

        }


        // UPDATE SIZE TEXT
        const selectedSizeInput = document.querySelector('.size-option input:checked');

        if(selectedSizeInput){
        const sizeValue = selectedSizeInput.value;
        const sizeGroup = selectedSizeInput.closest('.variant-group');
        const selectedText = sizeGroup.querySelector('.selected-option');

        if(selectedText){
            selectedText.textContent = sizeValue;
        }
        }


        // UPDATE COLOR TEXT
        const selectedColorInput = document.querySelector('.color-swatch input:checked');

        if(selectedColorInput){

        const colorValue = selectedColorInput.value;
        const colorGroup = selectedColorInput.closest('.variant-group');
        const selectedText = colorGroup.querySelector('.selected-option');

        if(selectedText){
            selectedText.textContent = colorValue;
        }

        }

    }


    // COLOR CLICK
    colorInputs.forEach(color => {
        color.addEventListener('click', () => {
        updateVariants(color.value);
        });
    });


    // PAGE LOAD
    const checkedColor = document.querySelector('.color-swatch input:checked');

    if(checkedColor){
        updateVariants(checkedColor.value);
    }else{
        // ONLY SIZE PRODUCT
        updateVariants();
    }
    // ==================== END :  Variant change dtock update JS ====================
    

    // ===================== START : Cart Count update JS ======================
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
    const res = await originalFetch(...args);

    if (args[0].includes('/cart/')) {
    fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
        document.querySelectorAll('.cart-count').forEach(el => {
            el.textContent = cart.item_count;
        });
        });
    }

    return res;
    };

    // ===================== END : Cart Count update JS ======================




});